import React from 'react'
import { Link } from 'react-router-dom'
import parse from 'html-react-parser';
import { getCourseLinks, getReplaceStudentPlanIdentifier } from '../../services/reservoir'
import connect from 'react-redux/es/connect/connect'

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse }, currentUser }) => {
  return {
    admissionCategory: selectedCourse.admissionCategory,
    userRole: currentUser.data['role'],
    userId: currentUser.data['vuId'],
    locationCode: selectedCourse.locationCd,
    courseId: selectedCourseCode,
    versionNo: selectedCourse.versionNumber,
    attemptNo: selectedCourse.attemptNumber
  }
}

class MyCourseFooter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loadingCourseLinks: true,
      courseLinks: []
    }
  }

  componentDidMount() {
    this.initialiseCourseLinks()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.admissionCategory !== this.props.admissionCategory) {
      this.initialiseCourseLinks()
    }
  }

  initialiseCourseLinks = () => {
    this.setState({
      loadingCourseLinks: true
    })

    getCourseLinks(this.props.admissionCategory, this.props.locationCode).then((courseLinks = []) => {
      this.setState({
        loadingCourseLinks: false,
        courseLinks: courseLinks
      })
    })
  }

  getLargeCourseLinks = () => {
    return this.state.courseLinks.filter(courseLink => {
      return courseLink.attributes && courseLink.attributes.field_link_size === 'LARGE'
    })
  }

  getMediumCourseLinks = () => {
    return this.state.courseLinks.filter(courseLink => {
      return courseLink.attributes && courseLink.attributes.field_link_size === 'MEDIUM'
    })
  }

  getSmallCourseLinks = () => {
    return this.state.courseLinks.filter(courseLink => {
      return courseLink.attributes && courseLink.attributes.field_link_size === 'SMALL'
    })
  }

  render() {
    // if (this.props.userRole != 'STUDENT') {
    //   return null
    // }

    return (
      <div className="critical-links__section" hidden={this.state.courseLinks.length === 0}>
        <div className="critical-links__container">
          <div className="row">
            <div className="col-xs-12 col-sm-6">
              <div className="row">
                {this.getLargeCourseLinks().map(courseLink => (
                  <div className="col-xs-12" key={courseLink.id}>
                    {courseLink.attributes.field_internal ? (
                      <Link className="link-box" to={courseLink.attributes.field_slug}>
                        <div>
                          <h3>{courseLink.attributes.field_heading_myvu_}</h3>
                          <p>{parse(courseLink.attributes.body.value)}</p>
                        </div>
                      </Link>
                    ) : (
                      <a
                        className="link-box"
                        href={
                          courseLink.attributes.field_slug.includes('$STDPLNID_MYVU$')
                            ? getReplaceStudentPlanIdentifier(courseLink.attributes.field_slug, this.props.userId, this.props.courseId, this.props.versionNo, this.props.attemptNo)
                            : courseLink.attributes.field_slug
                        }
                      >
                        <div>
                          <h3>{courseLink.attributes.field_heading_myvu_}</h3>
                          <p>{parse(courseLink.attributes.body.value)}</p>
                        </div>
                      </a>
                    )}
                  </div>
                ))}
                {this.getMediumCourseLinks().map(courseLink => (
                  <div className="col-xs-12 col-md-6" key={courseLink.id}>
                    {courseLink.attributes.field_internal ? (
                      <Link className="link-box" to={courseLink.attributes.field_slug}>
                        <h3>{courseLink.attributes.field_heading_myvu_}</h3>
                      </Link>
                    ) : (
                      <a
                        className="link-box"
                        href={
                          courseLink.attributes.field_slug.includes('$STDPLNID_MYVU$')
                            ? getReplaceStudentPlanIdentifier(courseLink.attributes.field_slug, this.props.userId, this.props.courseId, this.props.versionNo, this.props.attemptNo)
                            : courseLink.attributes.field_slug
                        }
                      >
                        <h3>{courseLink.attributes.field_heading_myvu_}</h3>
                      </a>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="col-xs-12 col-sm-6">
              <ul>
                {this.getSmallCourseLinks().map(courseLink => (
                  <li key={courseLink.id}>
                    {courseLink.attributes.field_internal ? (
                      <Link to={courseLink.attributes.field_slug}>{courseLink.attributes.field_heading_myvu_}</Link>
                    ) : (
                      <a
                        href={
                          courseLink.attributes.field_slug.includes('$STDPLNID_MYVU$')
                            ? getReplaceStudentPlanIdentifier(courseLink.attributes.field_slug, this.props.userId, this.props.courseId, this.props.versionNo, this.props.attemptNo)
                            : courseLink.attributes.field_slug
                        }
                      >
                        {courseLink.attributes.field_heading_myvu_}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(MyCourseFooter)
